export default __webpack_public_path__ + "files/media/seats.2e18760c.jpg";